// ACTION
export const SCREEN = {
  SET_SCREEN: 'SET_SCREEN',
};

// ACTION CREATORS
export function setScreen() {
  return {
    type: SCREEN.SET_SCREEN,
  }
}